import { Instagram, MessageCircle, MapPin } from "lucide-react";
import { SITE, buildWhatsappURL } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative pt-16 pb-10 px-4 sm:px-6 lg:px-8 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_gonomikai-launch/artifacts/plhlirsa_Wordmark%20WHT.png"
              alt="GoNomikai"
              className="h-16 sm:h-20 w-auto object-contain"
              style={{ mixBlendMode: "lighten" }}
            />
            <p className="mt-4 text-neutral-400 max-w-md text-sm">
              Gangtok's premium social stay. Boutique rooms, scenic dorms and a
              Tibetan-inspired bar — built for travellers who'd rather collect
              friends than souvenirs.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href={buildWhatsappURL()}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full glass flex items-center justify-center hover:bg-white/10 transition text-white"
                aria-label="WhatsApp"
                data-testid="footer-wa"
              >
                <MessageCircle size={16} />
              </a>
              <a
                href={SITE.instagram}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full glass flex items-center justify-center hover:bg-white/10 transition text-white"
                aria-label="Instagram"
                data-testid="footer-ig"
              >
                <Instagram size={16} />
              </a>
            </div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.22em] text-neutral-500 mb-3 font-semibold">Visit</div>
            <p className="text-sm text-neutral-300 flex items-start gap-2">
              <MapPin size={14} className="text-[#A7D38B] mt-1" />
              <span>
                {SITE.location}
                <br />
                <span className="text-neutral-500">{SITE.locationShort}</span>
              </span>
            </p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.22em] text-neutral-500 mb-3 font-semibold">Explore</div>
            <ul className="space-y-2 text-sm text-neutral-300">
              <li><a href="#rooms" className="hover:text-[#A7D38B]">Rooms</a></li>
              <li><a href="#experiences" className="hover:text-[#A7D38B]">Experiences</a></li>
              <li><a href="#food" className="hover:text-[#A7D38B]">Food & Bar</a></li>
              <li><a href="#events" className="hover:text-[#A7D38B]">Events</a></li>
            </ul>
          </div>
        </div>

        <div className="divider my-10" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-neutral-500">
          <div>© {new Date().getFullYear()} GoNomikai. Stay. Sip. Socialize.</div>
          <div>Crafted in the Himalayas · 乾杯</div>
        </div>
      </div>
    </footer>
  );
}
